import { HttpService } from "@/core";
import { DocPageReq, DocPageResp, DocReq, DocResp, LibraryPageReq, DownResp, FolderTreeResp, FolderResp } from "./project-document.interface";

export class ProjectDocumentService {
  static usePageApi() {
    const api = (params: DocPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/project_document/page",
        params,
      });
    return HttpService.usePagination<DocPageResp>(api);
  }

  static useCreateApi() {
    const api = (data: DocReq) =>
      HttpService.axios({
        method: "POST",
        url: "/project_document",
        data,
      });
    return HttpService.useRequest<DocResp>(api);
  }
  
  static useLibraryPageApi() {
    const api = (params: LibraryPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/project_folder/page",
        params,
      });
    return HttpService.usePagination<DocPageResp>(api);
  }


  static useLibraryDownApi() {
    const api = (id: String) =>
      HttpService.axios({
        method: "GET",
        url: `/project_folder/download/${id}`,
      });
    return HttpService.useRequest<DownResp>(api);
  }

  static useFolderTreeApi() {
    const api = (projectId: String) =>
      HttpService.axios({
        method: "GET",
        url: `/project_folder/sample/listAll?projectId=${projectId}`,
      });
    return HttpService.useRequest<FolderTreeResp>(api);
  }

  static useCreateFolderApi() {
    const api = (data: FolderResp) =>
      HttpService.axios({
        method: "POST",
        url: "/project_folder",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditFolderApi() {
    const api = (data: FolderResp) =>
      HttpService.axios({
        method: "PUT",
        url: `/project_folder/${data?.id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }


  static useDeleteFolderApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "POST",
        url: `/project_folder/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }
}
